var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5044 15.4449C10.3406 15.4449 10.1835 15.394 10.0676 15.3035C9.95179 15.213 9.88672 15.0903 9.88672 14.9623V6.04504C9.88672 5.91706 9.95179 5.79432 10.0676 5.70383C10.1835 5.61334 10.3406 5.5625 10.5044 5.5625C10.6682 5.5625 10.8253 5.61334 10.9411 5.70383C11.0569 5.79432 11.122 5.91706 11.122 6.04504V14.9623C11.122 15.0903 11.0569 15.213 10.9411 15.3035C10.8253 15.394 10.6682 15.4449 10.5044 15.4449Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9623 11.122H6.04504C5.91706 11.122 5.79432 11.0569 5.70383 10.9411C5.61334 10.8253 5.5625 10.6682 5.5625 10.5044C5.5625 10.3406 5.61334 10.1835 5.70383 10.0676C5.79432 9.95179 5.91706 9.88672 6.04504 9.88672H14.9623C15.0903 9.88672 15.213 9.95179 15.3035 10.0676C15.394 10.1835 15.4449 10.3406 15.4449 10.5044C15.4449 10.6682 15.394 10.8253 15.3035 10.9411C15.213 11.0569 15.0903 11.122 14.9623 11.122Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAdd);
export default __webpack_public_path__ + "static/media/circleAdd.2a057cefbfa2f6e2a314ea78662e258c.svg";
export { ForwardRef as ReactComponent };